// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";

// const CategoryList = () => {
//   const [CategoryUser, setCategoryUser] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchData = async () =>{
//       const response = await axios.post("https://cyberathon.com/multivendor/index.php/Api/Master_controller/category_list");
//       setCategoryUser(response.data.result);
//     }
//     fetchData();
//   }, []);

//   const deleteUser = async (userId) => {
//     try {
//       const response = await axios.post(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_category",
//         { cat_id: userId },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.data.success === "1") {
//         setCategoryUser((prevUser) =>
//           prevUser.filter((user) => user.cat_id !== userId)
//         );
//         toast.error(response.data.message || "Data Deleted Successfully!");
//         navigate("/category-list");
//       } else {
//         toast.error(response.data.error || "Delete failed.");
//       }
//     } catch (error) {
//       console.error("There was an error!", error);
//       toast.error("Failed to delete category.");
//     }
//   };

//   return (
//     <div className="page-content">
//       {/* Start Container Fluid */}
//       <div className="container-fluid">
//         {/* ========== Page Title Start ========== */}
//         <div className="row">
//           <div className="col-12">
//             <div className="page-title-box">
//               <h4 className="mb-0 fw-semibold">Categories List</h4>
//               <ol className="breadcrumb mb-0">
//                 <li className="breadcrumb-item">
//                   <Link to="javascript: void(0);">Categories</Link>
//                 </li>
//                 <li className="breadcrumb-item active">Categories List</li>
//               </ol>
//             </div>
//           </div>
//         </div>
//         {/* ========== Page Title End ========== */}
//         <div className="row">
//           <div className="col-md-6 col-xl-3">
//             <div className="card">
//               <div className="card-body text-center">
//                 <div className="rounded bg-secondary-subtle d-flex align-items-center justify-content-center mx-auto">
//                   <img
//                     src="/images/product/p-1.png"
//                     alt
//                     className="avatar-xl"
//                   />
//                 </div>
//                 <h4 className="mt-3 mb-0">Fashion Categories</h4>
//               </div>
//             </div>
//           </div>
//           <div className="col-md-6 col-xl-3">
//             <div className="card">
//               <div className="card-body text-center">
//                 <div className="rounded bg-primary-subtle d-flex align-items-center justify-content-center mx-auto">
//                   <img
//                     src="/images/product/p-6.png"
//                     alt
//                     className="avatar-xl"
//                   />
//                 </div>
//                 <h4 className="mt-3 mb-0">Electronics Headphone</h4>
//               </div>
//             </div>
//           </div>
//           <div className="col-md-6 col-xl-3">
//             <div className="card">
//               <div className="card-body text-center">
//                 <div className="rounded bg-warning-subtle d-flex align-items-center justify-content-center mx-auto">
//                   <img
//                     src="/images/product/p-7.png"
//                     alt
//                     className="avatar-xl"
//                   />
//                 </div>
//                 <h4 className="mt-3 mb-0">Foot Wares</h4>
//               </div>
//             </div>
//           </div>
//           <div className="col-md-6 col-xl-3">
//             <div className="card">
//               <div className="card-body text-center">
//                 <div className="rounded bg-info-subtle d-flex align-items-center justify-content-center mx-auto">
//                   <img
//                     src="/images/product/p-9.png"
//                     alt
//                     className="avatar-xl"
//                   />
//                 </div>
//                 <h4 className="mt-3 mb-0">Eye Ware &amp; Sunglass</h4>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="row">
//           <div className="col-xl-12">
//             <div className="card">
//               <div className="card-header d-flex justify-content-between align-items-center gap-1">
//                 <h4 className="card-title flex-grow-1">All Categories List</h4>
//                 <Link to="/category-add" className="btn btn-sm btn-primary">
//                   Add Category
//                 </Link>
//                 <div className="dropdown">
//                   <Link
//                     to="#"
//                     className="dropdown-toggle btn btn-sm btn-outline-light"
//                     data-bs-toggle="dropdown"
//                     aria-expanded="false"
//                   >
//                     This Month
//                   </Link>
//                   <div className="dropdown-menu dropdown-menu-end">
//                     {/* item*/}
//                     <Link to="#!" className="dropdown-item">
//                       Download
//                     </Link>
//                     {/* item*/}
//                     <Link to="#!" className="dropdown-item">
//                       Export
//                     </Link>
//                     {/* item*/}
//                     <Link to="#!" className="dropdown-item">
//                       Import
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="table-responsive">
//                   <table className="table align-middle mb-0 table-hover table-centered">
//                     <thead className="bg-light-subtle">
//                       <tr>
//                         <th style={{ width: "20px" }}>
//                           <div className="form-check fs-16 ms-1">
//                             <input
//                               type="checkbox"
//                               className="form-check-input"
//                               id="customCheck1"
//                             />
//                             <label
//                               className="form-check-label"
//                               htmlFor="customCheck1"
//                             />
//                           </div>
//                         </th>
//                         <th>Categories</th>
//                         <th>Create by</th>
//                         <th>Product Stock</th>
//                         <th>Status</th>
//                         <th>Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {CategoryUser.map((user, index) => {
//                         return (
//                           <tr key={index}>
//                             <td>
//                               <div className="form-check fs-16 ms-1">
//                                 <input
//                                   type="checkbox"
//                                   className="form-check-input"
//                                   id="customCheck2"
//                                 />
//                                 <label
//                                   className="form-check-label"
//                                   htmlFor="customCheck2"
//                                 />
//                               </div>
//                             </td>
//                             <td>
//                               <div className="d-flex align-items-center gap-2">
//                                 <div className="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
//                                   <img
//                                     src={`https://cyberathon.com/multivendor/${user.cat_image}`}
//                                     alt="Banner Image"
//                                     className="avatar-md"
//                                   />
//                                 </div>
//                                 <p className="text-dark fw-medium fs-15 mb-0">
//                                   {user.cat_name}
//                                 </p>
//                               </div>
//                             </td>
//                             {/* <td>$80 to $400</td> */}
//                             <td>{user.cat_created_by}</td>
//                             <td>{user.cat_stock}</td>
//                                 <td>
//                             <span
//                               className={`badge ${
//                                 user.status === "active"
//                                   ? "bg-success-subtle text-success"
//                                   : "bg-danger-subtle text-danger"
//                               } py-1 px-2`}
//                             >
//                               {user.status}
//                             </span>
//                           </td>
//                             <td>
//                               <div className="d-flex gap-2">
//                                 <Link
//                                   to={`/category-view/${user.cat_id}`}
//                                   className="btn btn-light btn-sm"
//                                 >
//                                   <i className="fa-solid fa-eye align-middle fs-18"></i>
//                                 </Link>
//                                 <Link
//                                   to={`/category-edit/${user.cat_id}`}
//                                   className="btn btn-soft-primary btn-sm"
//                                 >
//                                   <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                                 </Link>
//                                 <span
//                                   onClick={() => deleteUser(user.cat_id)}
//                                   className="btn btn-soft-danger btn-sm"
//                                 >
//                                   <i class="fa-solid fa-trash align-middle fs-18"></i>
//                                 </span>
//                               </div>
//                             </td>
//                           </tr>
//                         );
//                       })}
//                     </tbody>
//                   </table>
//                 </div>
//                 {/* end table-responsive */}
//               </div>
//               <div className="card-footer border-top">
//                 <nav aria-label="Page navigation example">
//                   <ul className="pagination justify-content-end mb-0">
//                     <li className="page-item">
//                       <Link tosName="page-link" href="javascript:void(0);">
//                         Previous
//                       </Link>
//                     </li>
//                     <li className="page-item active">
//                       <Link tosName="page-link" href="javascript:void(0);">
//                         1
//                       </Link>
//                     </li>
//                     <li className="page-item">
//                       <Link tosName="page-link" href="javascript:void(0);">
//                         2
//                       </Link>
//                     </li>
//                     <li className="page-item">
//                       <Link tosName="page-link" href="javascript:void(0);">
//                         3
//                       </Link>
//                     </li>
//                     <li className="page-item">
//                       <Link tosName="page-link" href="javascript:void(0);">
//                         Next
//                       </Link>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* End Container Fluid */}
//       {/* ========== Footer Start ========== */}
//       <footer className="footer">
//         <div className="container-fluid">
//           <div className="row">
//             <div className="col-12 text-center">
//               © Venton. Crafted by{" "}
//               <iconify-icon
//                 icon="iconamoon:heart-duotone"
//                 className="fs-18 align-middle text-danger"
//               />{" "}
//               <Link to className="fw-bold footer-text" target="_blank">
//                 Techzaa
//               </Link>
//             </div>
//           </div>
//         </div>
//       </footer>
//       {/* ========== Footer End ========== */}
//     </div>
//   );
// };

// export default CategoryList;

import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CategoryList = () => {
  const [CategoryUser, setCategoryUser] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // ✅ Correct API (GET)
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
        );

        if (response.data.success === "1") {
          setCategoryUser(response.data.row); // correct response key
        } else {
          toast.error("Failed to fetch categories");
        }
      } catch (error) {
        console.error(error);
        toast.error("API Error");
      }
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
  try {
    const formData = new FormData();
    formData.append("category_id", userId);

    console.log("Deleting category ID:", userId);

    const response = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_main_category",
      formData, // ✅ PASS DIRECTLY
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log("Delete response:", response.data);

    if (response.data.success === "1" || response.data.status === true) {
      setCategoryUser((prev) =>
        prev.filter((user) => user.category_id !== userId)
      );
      toast.error(response.data.message || "Category deleted successfully");
    } else {
      toast.error(response.data.message || "Delete failed");
    }
  } catch (error) {
    console.error("Delete error", error);
    toast.error("Failed to delete category.");
  }
};


  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Categories List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="javascript: void(0);">Categories</Link>
                </li>
                <li className="breadcrumb-item active">Categories List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* 4 Cards Section — NOT CHANGED */}
        {/* <div className="row">
          <div className="col-md-6 col-xl-3">
            <div className="card text-center">
              <div className="card-body">
                <div className="rounded bg-secondary-subtle d-flex align-items-center justify-content-center mx-auto">
                  <img src="/images/product/p-1.png" className="avatar-xl" alt="" />
                </div>
                <h4 className="mt-3 mb-0">Fashion Categories</h4>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card text-center">
              <div className="card-body">
                <div className="rounded bg-primary-subtle d-flex align-items-center justify-content-center mx-auto">
                  <img src="/images/product/p-6.png" className="avatar-xl" alt="" />
                </div>
                <h4 className="mt-3 mb-0">Electronics Headphone</h4>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card text-center">
              <div className="card-body">
                <div className="rounded bg-warning-subtle d-flex align-items-center justify-content-center mx-auto">
                  <img src="/images/product/p-7.png" className="avatar-xl" alt="" />
                </div>
                <h4 className="mt-3 mb-0">Foot Wares</h4>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card text-center">
              <div className="card-body">
                <div className="rounded bg-info-subtle d-flex align-items-center justify-content-center mx-auto">
                  <img src="/images/product/p-9.png" className="avatar-xl" alt="" />
                </div>
                <h4 className="mt-3 mb-0">Eye Ware & Sunglass</h4>
              </div>
            </div>
          </div>
        </div> */}

        {/* Category Table */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title flex-grow-1">All Categories List</h4>
                <Link to="/category-add" className="btn btn-sm btn-primary">
                  Add Category
                </Link>
              </div>

              <div className="table-responsive">
                <table className="table align-middle mb-0 table-hover table-centered">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th></th>
                      <th>Categories</th>
                      <th>Create Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {CategoryUser.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <input type="checkbox" className="form-check-input" />
                        </td>

                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <div className="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                              <img
                                src={
                                  item.image
                                    ? `https://cyberathon.com/multivendor/${item.image}`
                                    : "/images/no-image.png"
                                }
                                alt="Category"
                                className="avatar-md"
                              />
                            </div>

                            <p className="text-dark fw-medium fs-15 mb-0">
                              {item.category_name}
                            </p>
                          </div>
                        </td>

                        <td>{item.created_at}</td>

                        <td>
                          <div className="d-flex gap-2">
                            <Link
                              to={`/category-view/${item.category_id}`}
                              className="btn btn-light btn-sm"
                            >
                              <i className="fa-solid fa-eye fs-18"></i>
                            </Link>

                            <Link
                              to={`/category-edit/${item.category_id}`}
                              className="btn btn-soft-primary btn-sm"
                            >
                              <i className="fa-solid fa-pencil fs-18"></i>
                            </Link>

                            <span
                              onClick={() => deleteUser(item.category_id)}
                              className="btn btn-soft-danger btn-sm"
                            >
                              <i className="fa-solid fa-trash fs-18"></i>
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination (Not changed) */}
              <div className="card-footer border-top">
                <nav>
                  <ul className="pagination justify-content-end mb-0">
                    <li className="page-item">
                      <Link className="page-link">Previous</Link>
                    </li>
                    <li className="page-item active">
                      <Link className="page-link">1</Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link">2</Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link">3</Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link">Next</Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
            <footer className="footer">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 text-center">
                    © Venton. Crafted by{" "}
                    <iconify-icon
                      icon="iconamoon:heart-duotone"
                      className="fs-18 align-middle text-danger"
                    />{" "}
                    <Link to="#" className="fw-bold footer-text" target="_blank">
                      Techzaa
                    </Link>
                  </div>
                </div>
              </div>
            </footer>
    </div>
  );
};

export default CategoryList;